import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import SectionTitle2 from "../SectionTitle2/SectionTitle2";
import { getServices } from "../../api/service";
import DOMPurify from "dompurify";

const settings = {
  dots: true,
  arrows: false,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        centerMode: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
      },
    },
  ],
};

const ClickHandler = () => {
  window.scrollTo({
    top: 0, // scroll to the top
    left: 10, // horizontal scroll (you can set 0 if not needed)
    behavior: "smooth", // enables smooth scrolling
  });
};

const stripHtml = (html) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = DOMPurify.sanitize(html);
  return tempDiv.textContent || tempDiv.innerText || "";
};

const ServiceSection = () => {
  const [services, setServices] = useState([]);
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

  useEffect(() => {
    getServices().then(setServices);
  }, []);

  if (!services) return null;

  return (
    <section
      className="wpo-service-section section-padding"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        color: "#fff",
      }}
    >
      <div className="container">
        <SectionTitle2
          subTitle={"Our Services"}
          Title={"All StarFamily Solutions"}
        />
        <div className="row-grid wpo-service-slider owl-carousel">
          <Slider {...settings}>
            {services.map((service, srv) => (
              <div className="grid" key={srv} style={{ padding: "0 10px" }}>
                <div
                  className="wpo-service-item"
                  style={{
                    minHeight: "auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    flex: "1",
                  }}
                >
                  <div
                    className="wpo-service-img"
                    style={{
                      width: "100%",
                      height: "340px",
                      overflow: "hidden",
                      borderRadius: "10px",
                    }}
                  >
                    <img
                      src={`${apiUrl}/storage/` + service.banner}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                    <div
                      className="wpo-service-text"
                      style={{
                        padding: "15px",
                        textAlign: "center",
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                        {service.serviceName}
                      </h2>
                      <p
                        style={{ fontSize: "14px" }}
                        dangerouslySetInnerHTML={{
                          __html: service.description,
                        }}
                      />
                      <Link
                        onClick={ClickHandler}
                        to={{
                          pathname: `/service-single/${service.id}`,
                          state: { allServices: services },
                        }}
                        style={{
                          alignSelf: "center",
                          cursor: "pointer",
                          zIndex: "10",
                          color: "#fff",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "transparent";
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        Details
                      </Link>
                    </div>
                    <div
                      className="wpo-service-hidden-text"
                      style={{
                        padding: "15px",
                        textAlign: "center",
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                        {service.serviceName}
                      </h2>
                      <p style={{ fontSize: "14px" }}>
                        {stripHtml(service.description).length > 100
                          ? stripHtml(service.description).slice(0, 100) + "..."
                          : stripHtml(service.description)}
                      </p>
                      <Link
                        onClick={ClickHandler}
                        to={{
                          pathname: `/service-single/${service.id}`,
                          state: { allServices: services },
                        }}
                        style={{
                          alignSelf: "center",
                          cursor: "pointer",
                          zIndex: "10",
                          color: "#fff",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "transparent";
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        Details
                      </Link>
                      <div className="top-shape">
                        <div className="shape-1"></div>
                        <div className="shape-2"></div>
                        <div className="shape-3"></div>
                      </div>
                      <div className="bottom-shape">
                        <div className="shape-1"></div>
                        <div className="shape-2"></div>
                        <div className="shape-3"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
